import React from "react";
const CoursesInPackage = ({
  coursesData,
  totalPrice,
  totalPvDirect,
  registrationPrice,
}) => {
  return (
    <section className="tw-container tw-mx-auto tw-p-5 tw-bg-white tw-rounded-[10px] tw-shadow-md">
      <div className="tw-mb-4 tw-border-b tw-pb-2 tw-flex tw-justify-between tw-items-center">
        <h3 className="tw-text-xl tw-font-semibold tw-text-red-600 !tw-m-0">
          Courses In Package
        </h3>
        <div
          className="tw-text-[#5A5959] tw-text-lg tw-font-light"
          style={{ textShadow: "0px 4px 7.4px 0px rgba(0,0,0,0.4)" }}
        >
          <span>{totalPvDirect} PV</span>
          <span className="tw-text-xl tw-px-2">/</span>
          <span>{totalPrice} E.M</span>
        </div>
      </div>
      <div className="tw-flex max-lg:tw-flex-col tw-items-end tw-gap-4">
        {coursesData.length == 0 ? (
          <p>No data is available in the notes history.</p>
        ) : (
          <div className="tw-overflow-x-auto tw-w-full">
            <table className="tw-w-full tw-bg-white tw-rounded-lg tw-font-semibold ">
              <thead className="tw-whitespace-nowrap">
                <tr>
                  <th className="tw-py-2 tw-text-left tw-text-md tw-font-bold tw-text-primary tw-uppercase tw-tracking-wider">
                    Courses ({coursesData.length})
                  </th>
                  <th className="tw-py-2 tw-text-left tw-text-md tw-font-bold tw-text-primary tw-uppercase">
                    E-Money
                  </th>
                  <th className="tw-py-2 tw-text-left tw-text-md tw-font-bold tw-text-primary tw-uppercase ">
                    PV value
                  </th>
                </tr>
              </thead>
              <tr>
                <td className="tw-py-2 tw-whitespace-nowrap tw-text-sm">
                  Registeration Fees
                </td>
                <td className="tw-py-2 tw-whitespace-nowrap tw-text-sm">
                  {registrationPrice}
                </td>
              </tr>
              <tbody>
                {coursesData?.map((c, index) => (
                  <tr key={index}>
                    <td className="tw-py-2 tw-whitespace-nowrap tw-text-sm">
                      <img
                        src={c.courseImage}
                        alt="courseImage"
                        className="tw-inline-block tw-me-2 tw-w-10"
                      ></img>
                      {c.courseName}
                    </td>
                    <td className="tw-py-2 tw-whitespace-nowrap tw-text-sm">
                      {c?.["courseE-money"] > 0 ? c?.["courseE-money"] : "Free"}
                    </td>
                    <td className="tw-py-2 tw-whitespace-nowrap tw-text-sm">
                      {c?.coursePvDirect}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};

export default CoursesInPackage;
